const LOCAL_ENVIRONMENTS = ["127.0.0.1", "localhost"];
const DEV_ENVIRONMENTS = ["app.devswapglobal.com", ...LOCAL_ENVIRONMENTS];
const STAGING__ENVIRONMENTS = ["app.staging-swapglobal.com"];

export function isLocalDevelopmentEnvironment() {
  const { hostname } = window.location;
  const result = [DEV_ENVIRONMENTS[1], DEV_ENVIRONMENTS[2]].find((env) => hostname.endsWith(env));
  return !!result;
}

export function isLocalEnvironment() {
  const { hostname } = window.location;
  const result = LOCAL_ENVIRONMENTS.find((env) => hostname.endsWith(env));
  return !!result;
}

export function isDevelopmentEnvironment() {
  const { hostname } = window.location;
  const result = DEV_ENVIRONMENTS.find((env) => hostname.endsWith(env));
  return !!result;
}

export function isStagingEnvironment() {
  const { hostname } = window.location;
  const result = STAGING__ENVIRONMENTS.find((env) => hostname.endsWith(env));
  return !!result;
}

export function getEnvironmentName() {
  if (isLocalDevelopmentEnvironment()) return "LOCAL";
  if (isDevelopmentEnvironment()) return "DEV";
  if (isStagingEnvironment()) return "STAGING";
  return "PROD";
}

export function isProduction() {
  return !isLocalDevelopmentEnvironment() && !isDevelopmentEnvironment() && !isStagingEnvironment();
}

export function getApiDocsUrl() {
  const { hostname, origin } = window.location;

  if (hostname === "localhost") return "https://docs.devswapglobal.com";
  return origin.replace("app", "docs");
}
